// extracted by css-extract-rspack-plugin
export default {"modalImgHeight":"aCFGRXaYYm3E6w3L__modalImgHeight___"};